/*
**  rui-fixed-layout-element.js
**
**  rui-fixed-layout-element component
*/
import { LitElement, html, css } from 'lit';
import { ruiCommonStylesFixedLayout } from '../common/rui-common-styles-fixed-layout.js';
export class RuiFixedLayoutElement extends LitElement {
    static get is() {
        return 'rui-fixed-layout-element';
    }
    static get properties() {
        return {
            width: { type: String },
            height: { type: String }
        };
    }
    constructor() {
        super();
        this.width = '';
        this.height = '';
    }
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('rui-fixed-layout-vertical-scrolling', (e) => this.fixedLayoutVerticalScrolling(e));
        this.addEventListener('rui-display-block-collapse-expand', (e) => this.displayBlockCollapseExpand(e));
    }
    disconnectedCallback() {
        window.removeEventListener('rui-fixed-layout-vertical-scrolling', (e) => this.fixedLayoutVerticalScrolling(e));
        this.removeEventListener('rui-display-block-collapse-expand', (e) => this.displayBlockCollapseExpand(e));
        super.disconnectedCallback();
    }
    fixedLayoutVerticalScrolling(e) {
        if (e.detail) {
            this.setAttribute('data-rui-fixed-layout-vertical-scrolling', '');
        }
        else {
            this.removeAttribute('data-rui-fixed-layout-vertical-scrolling');
        }
    }
    displayBlockCollapseExpand(e) {
        let isCollapsed = e.detail.isCollapsed;
        let collapseDirection = e.detail.collapseDirection.toLowerCase();
        if (isCollapsed) {
            this.setAttribute('data-rui-display-block-collapsed-' + collapseDirection, '');
        }
        else {
            this.removeAttribute('data-rui-display-block-collapsed-' + collapseDirection);
        }
    }
    render() {
        // All the real work here is done using :host + attributes in the component's CSS
        return html `<slot></slot>`;
    }
    static get styles() {
        return [
            ruiCommonStylesFixedLayout,
            css `
                :host([data-rui-display-block-collapsed-left]),
                :host([data-rui-display-block-collapsed-right]) {
                    max-width: 60px;
                }
                
                :host([data-rui-display-block-collapsed-up]),
                :host([data-rui-display-block-collapsed-down]) {
                    max-height: 60px;
                    height: 60px;
                }
            `
        ];
    }
}
customElements.get(RuiFixedLayoutElement.is) || customElements.define(RuiFixedLayoutElement.is, RuiFixedLayoutElement);
